import AuthService from "./AuthService";
import { SystemService } from './SystemService';

export class MachinesService {
    systemService = null;
    api = null;
    authService = null;
    
    constructor(){
        this.systemService = new SystemService();
        this.authService = new AuthService();
        this.api = this.systemService.getApiAccess();
    }

    getMachines(wh){
        let sessionid = this.authService.getSessionId();
        let url = 'machines';
        const selectedWh = wh !== undefined ? wh : this.authService.getConfig()?.whCode;
        if (selectedWh) {
            url += `?wh=${selectedWh}`;
        }
        let machinesPromise = new Promise((resolve, reject) => {
            this.api.get(url, {
                headers: {
                    authorization: sessionid
                }
            }).then(r => resolve(r.data)).catch(e => reject(e.message));
        });
        return machinesPromise;
    }
}
